const parseSeatSelectionConfig = (root) => {
	const script = root.parentElement?.querySelector('[data-seat-selection-config]') || document.querySelector('[data-seat-selection-config]');
	if (!script) return null;
	try { return JSON.parse(script.textContent); } catch { return null; }
};

const postSeatSelection = async (endpoint, payload) => {
	const response = await fetch(endpoint, {
		method: 'POST',
		headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
		body: JSON.stringify(payload),
	});
	const result = await response.json();
	if (!response.ok || (result.error && !result.korpa)) throw new Error(result.errorMessage || 'Unable to update ticket selection.');
	return result;
};

document.querySelectorAll('[data-seat-selection]').forEach((root) => {
	const config = parseSeatSelectionConfig(root);
	if (!config) return;
	const summary = root.querySelector('[data-selection-summary]');
	const proceed = root.querySelector('#proceedwithshopping');
	const blocker = root.querySelector('.np-seat-blocker');
	const message = root.querySelector('[data-seat-message]');
	let selectedCount = 0;
	let expiryTimer = null;

	const setBusy = (busy) => {
		root.classList.toggle('is-busy', busy);
		if (blocker) blocker.hidden = !busy;
	};
	const showMessage = (text) => {
		if (!message) return;
		message.textContent = text;
		message.hidden = !text;
	};
	const updateSummary = (result) => {
		selectedCount = Number(result.komada || 0);
		if (summary && typeof result.korpa === 'string') summary.innerHTML = result.korpa;
		if (proceed) proceed.hidden = selectedCount < 1;
		const counts = document.querySelectorAll('#mycartkarata, [data-cart-count]');
		const amount = document.querySelector('#mycartiznos');
		counts.forEach((count) => { count.textContent = String(selectedCount); });
		if (amount) amount.textContent = new Intl.NumberFormat().format(Number(result.iznos || 0));
	};
	const updateSeatStates = (states) => {
		Object.entries(states || {}).forEach(([id, state]) => {
			const seat = document.getElementById(id);
			if (!seat) return;
			seat.classList.remove('prodato', 'poruceno');
			if (Number(state) === 0) seat.classList.add('prodato');
			if (Number(state) === 2) seat.classList.add('poruceno');
			seat.disabled = Number(state) === 0;
			seat.setAttribute('aria-pressed', Number(state) === 2 ? 'true' : 'false');
		});
	};
	const restartExpiry = () => {
		if (expiryTimer) window.clearTimeout(expiryTimer);
		if (selectedCount > 0) expiryTimer = window.setTimeout(() => window.location.reload(), (Number(config.holdingSeconds) + 2) * 1000);
	};

	root.addEventListener('click', async (event) => {
		const seat = event.target.closest('.np-seat');
		if (!seat || seat.disabled || seat.classList.contains('prodato') || root.classList.contains('is-busy')) return;
		if (selectedCount >= Number(config.maxTickets) && !seat.classList.contains('poruceno')) {
			showMessage(String(config.limitMessage || '').replace('##1', String(config.maxTickets)));
			return;
		}
		showMessage('');
		setBusy(true);
		try {
			const result = await postSeatSelection(config.endpoint, {fn: 'ticket_click', i: config.performanceId, ticket: Number(seat.dataset.pid), type: seat.classList.contains('poruceno') ? 0 : 1});
			updateSeatStates(result.seats);
			updateSummary(result);
			restartExpiry();
		} catch (error) {
			showMessage(error instanceof Error ? error.message : 'Unable to update ticket selection.');
		} finally { setBusy(false); }
	});

	proceed?.addEventListener('click', async () => {
		if (selectedCount < 1 || root.classList.contains('is-busy')) return;
		setBusy(true);
		try {
			await postSeatSelection(config.endpoint, {fn: 'addToCart'});
			window.location.assign(config.cartUrl);
		} catch (error) {
			showMessage(error instanceof Error ? error.message : 'Unable to add tickets to the order.');
			setBusy(false);
		}
	});

	postSeatSelection(config.endpoint, {fn: 'init_kupac_na_blagajni'})
		.then((result) => { updateSummary(result); restartExpiry(); })
		.catch((error) => showMessage(error instanceof Error ? error.message : 'Unable to load ticket selection.'));
});
